module.exports = __webpack_public_path__ + "img/UntenImSchachtFuesseObenTransp.43da56d9.png";